import { User } from '.';

export interface AwardLead {
  awardLeadId: number;
  awardId: number;
  emailAddress: string;
  user?: User;
  isPrimary: boolean;
}

export function blankAwardLead(): AwardLead {
  return {
    awardLeadId: 0,
    awardId: 0,
    emailAddress: '',
    isPrimary: false
  };
}

export function copyAwardLead(awardLead: AwardLead): AwardLead {
  return {
    awardLeadId: awardLead.awardLeadId,
    awardId: awardLead.awardId,
    emailAddress: awardLead.emailAddress,
    isPrimary: awardLead.isPrimary,
  };
}

export function compareAwardLead(awardLeadA: AwardLead, awardLeadB: AwardLead): boolean {
  return awardLeadA.emailAddress === awardLeadB.emailAddress && awardLeadA.isPrimary === awardLeadB.isPrimary;
}
